import React, { useState } from 'react';
import { TrendingDown, TrendingUp, Award } from 'lucide-react';

export const HandicapTracker = ({ handicap, onUpdate }) => {
  const [showForm, setShowForm] = useState(false);
  const [newHandicap, setNewHandicap] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const value = parseFloat(newHandicap);
    
    if (isNaN(value) || value < -5 || value > 54) {
      setError('Handicap must be between -5.0 and 54.0');
      return;
    }

    onUpdate(value);
    setNewHandicap('');
    setShowForm(false);
    setError('');
  };

  const getRankSuffix = (rank) => {
    if (!rank) return '';
    const j = rank % 10;
    const k = rank % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
  };

  return (
    <div className="handicap-card">
      <div className="card-header">
        <h3>GHIN Handicap Tracker</h3>
        {!showForm && (
          <button onClick={() => setShowForm(true)} className="btn-primary-sm">
            Update Handicap
          </button>
        )}
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="handicap-form">
          <div className="form-group">
            <label>Enter Your Current Handicap Index</label>
            <input
              type="number"
              step="0.1"
              value={newHandicap}
              onChange={(e) => setNewHandicap(e.target.value)}
              placeholder="e.g., 15.4"
              className="form-input"
              autoFocus
            />
            {error && <small className="error-text">{error}</small>}
          </div>
          <div className="button-group">
            <button type="submit" className="btn-primary-sm">Save</button>
            <button type="button" onClick={() => { setShowForm(false); setError(''); }} className="btn-outline-sm">
              Cancel
            </button>
          </div>
        </form>
      )}

      {handicap && handicap.current_handicap_index !== null && handicap.current_handicap_index !== undefined ? (
        <div className="handicap-current">
          <div className="handicap-value">
            <div className="handicap-number">{handicap.current_handicap_index.toFixed(1)}</div>
            <div className="handicap-label">Current Index</div>
          </div>

          {handicap.rank && (
            <div className="handicap-rank">
              <Award className="rank-icon" />
              <div>
                <div className="rank-text">
                  You are currently ranked <strong>{handicap.rank}{getRankSuffix(handicap.rank)}</strong> out of <strong>{handicap.total_members}</strong> members
                </div>
              </div>
            </div>
          )}

          {handicap.entries && handicap.entries.length > 1 && (
            <div className="handicap-history">
              <h4>Recent History</h4>
              <div className="history-list">
                {handicap.entries.slice(-5).reverse().map((entry, index) => (
                  <div key={`handicap-${entry.date || ''}-${entry.handicap_index}-${index}`} className="history-item">
                    <span className="history-date">
                      {new Date(entry.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </span>
                    <span className="history-value">{entry.handicap_index.toFixed(1)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="handicap-empty">
          <TrendingDown size={48} className="empty-icon" />
          <p>No handicap entered yet</p>
          <small>Enter your GHIN handicap index to track your progress and compete for prizes</small>
        </div>
      )}
    </div>
  );
};